
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/pallet-disposal",
      function () {
        return require("private-next-pages/pallet-disposal/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/pallet-disposal"])
      });
    }
  